<template>
  <v-sheet
    v-if="showSimulator"
    border
    rounded
    class="pa-3 mb-3"
    data-testid="stripe-reader-simulator"
  >
    <p class="text-caption mb-2">
      DEV only: act as the cardholder on a Stripe simulated reader. Stripe sends
      the resulting webhooks as if a real card were used.
    </p>
    <div class="d-flex flex-wrap ga-2 align-center">
      <v-select
        v-model="simulation"
        :items="simulations"
        label="Simulated cardholder action"
        density="compact"
        hide-details
        style="min-width: 240px"
        :disabled="disabled"
      />
      <v-btn
        variant="tonal"
        :disabled="disabled || !readerId"
        @click="emit('simulate', simulation)"
        >Simulate on reader</v-btn
      >
    </div>
    <p
      v-if="outcome"
      class="text-caption mt-2 mb-0"
      data-testid="stripe-reader-simulation-outcome"
    >
      {{ outcome }}
    </p>
  </v-sheet>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useEnv } from "@/composables/useEnv";
import { StripeReaderSimulation } from "../../../cbi-generator/generated/dto/StripeReaderSimulation";

defineProps<{ readerId: string; disabled?: boolean; outcome?: string }>();
const emit = defineEmits<{ simulate: [simulation: StripeReaderSimulation] }>();

// The backend also refuses unless it is a DEV server with a Stripe test key.
const showSimulator = computed(() => useEnv().environment === "development");

const labels: Record<StripeReaderSimulation, string> = {
  [StripeReaderSimulation.APPROVE]: "Tap approved card",
  [StripeReaderSimulation.DECLINE]: "Tap declined card",
  [StripeReaderSimulation.INSUFFICIENT_FUNDS]: "Insufficient funds",
  [StripeReaderSimulation.EXPIRED_CARD]: "Expired card",
  [StripeReaderSimulation.LOST_CARD]: "Lost card",
  [StripeReaderSimulation.STOLEN_CARD]: "Stolen card",
  [StripeReaderSimulation.PROCESSING_ERROR]: "Processing error",
  [StripeReaderSimulation.REFUND_FAIL]: "Card whose refunds fail later",
  [StripeReaderSimulation.SUCCEED_INPUT_COLLECTION]:
    "Complete input collection",
  [StripeReaderSimulation.TIMEOUT_INPUT_COLLECTION]:
    "Time out input collection",
};
const simulations = Object.values(StripeReaderSimulation).map((value) => ({
  value,
  title: labels[value],
}));
const simulation = ref(StripeReaderSimulation.APPROVE);
</script>
